import {MainState} from './state';
import {getStoreAccessors} from 'typesafe-vuex';
import {State} from '../state';

export const getters = {
    hasAdminAccess: (state: MainState) => {
        return state.userProfile?.is_superuser;
    },
    hasModuleAccess: (state: MainState) => (payload: any) => {
        if (state.userProfile?.is_superuser) { return true; }

        if (!payload?.module) {
            return false;
        } else if (payload.module === 'main') {
            return true;
        }
        // First of all, check into the all permissions module
        const permissions: JSON = state.userProfile.all_permissions;

        if (Object.keys(permissions).length > 0){
            return permissions[payload.module]?.methods.includes(payload.method)
        }

        const userProfileSettings = state.userProfile?.role?.settings?.permissions;
        if (userProfileSettings) {
            return userProfileSettings[payload.module]?.methods[payload.method];
        }
        return false;
    },
    loginError: (state: MainState) => state.logInError,
    noServerConnection: (state: MainState) => state.noServerConnection,
    dashboardShowDrawer: (state: MainState) => state.dashboardShowDrawer,
    dashboardMiniDrawer: (state: MainState) => state.dashboardMiniDrawer,
    userProfile: (state: MainState) => state.userProfile,
    userProfileStats: (state: MainState) => state.userStats,
    userProfileSetting: (state: MainState) => state.userProfile?.role?.settings?.permissions,
    token: (state: MainState) => state.token,
    isLoggedIn: (state: MainState) => state.isLoggedIn,
    firstNotification: (state: MainState) => state.notifications.length > 0 && state.notifications[0],

    form: (state: MainState) => (formId: number) => {
        const filteredForms = state.forms.filter((form) => form.id === formId);
        if (filteredForms.length > 0) {
            return {...filteredForms[0]};
        }
    },
    forms: (state: MainState) => state.forms,
    menu_form: (state: MainState) => (id: number) => {
        const filteredForms = state.menu_forms.filter((form) => form.id === id);
        if (filteredForms.length > 0) {
            return {...filteredForms[0]};
        }
    },
    menu_forms: (state: MainState) => state.menu_forms,
    current_form_values: (state: MainState) => state.form_values,
    form_values: (state: MainState) => (formId: number) => {
        const filteredFormsValues = state.forms_values.filter((formValues) => formValues.id === formId);
        if (filteredFormsValues.length > 0) {
            return {...filteredFormsValues[0]};
        }
    },
    forms_file: (state: MainState) => (formId: number) => {
        const filtered = state.forms_files.filter((item) => item.id === formId);
        if (filtered.length > 0) {
            return {...filtered[0]};
        }
    },
    forms_values: (state: MainState) => state.forms_values,

    external_data: (state: MainState) => state.external_data,

    search_engine: (state: MainState) => state.search_engine,

    form_batches: (state: MainState) => state.form_batches?.items,
    form_batches_stats: (state: MainState) => state.form_batches?.stats,
    form_batch: (state: MainState) => (formId: number) => {
        const filtered = state.form_batches?.items?.filter((item) => item.id === formId);
        // @ts-ignore
        if (filtered?.length > 0) {
            // @ts-ignore
            return {...filtered[0]};
        }
    },

    query_builder: (state: MainState) => state.query_builder,

    printer_log: (state: MainState) => (plId: number) => {
        const filtered = state.printer_logs.filter((item) => item.id === plId);
        if (filtered.length > 0) {
            return {...filtered[0]};
        }
    },
    printer_logs: (state: MainState) => state.printer_logs,
    current_printer_log: (state: MainState) => state.printer_log,



    access_log: (state: MainState) => (id: number) => {
        const filtered = state.access_logs.filter((item) => item.id === id);
        if (filtered.length > 0) {
            return {...filtered[0]};
        }
    },
    access_logs: (state: MainState) => state.access_logs,
    visited_pages: (state: MainState) => {
        const pages = localStorage.getItem('latest_visited_pages');
        return pages ? JSON.parse(pages) : [];
    },

    permissions: (state: MainState) => state.permissions,
};

const {read} = getStoreAccessors<MainState, State>('');

export const readDashboardMiniDrawer = read(getters.dashboardMiniDrawer);
export const readDashboardShowDrawer = read(getters.dashboardShowDrawer);
export const readHasAdminAccess = read(getters.hasAdminAccess);
export const readHasModuleAccess = read(getters.hasModuleAccess);
export const readIsLoggedIn = read(getters.isLoggedIn);
export const readLoginError = read(getters.loginError);
export const readNoServerConnection = read(getters.noServerConnection);
export const readToken = read(getters.token);
export const readUserProfile = read(getters.userProfile);
export const readUserProfileStats = read(getters.userProfileStats);
export const readUserProfileSetting = read(getters.userProfileSetting);
export const readFirstNotification = read(getters.firstNotification);

export const readForm = read(getters.form);
export const readForms = read(getters.forms);

export const readMenuForm = read(getters.menu_form);
export const readMenuForms = read(getters.menu_forms);
export const readFormsFile = read(getters.forms_file);

export const readFormValues = read(getters.form_values);
export const readCurrentFormValues = read(getters.current_form_values);
export const readFormsValues = read(getters.forms_values);

export const readExternalData = read(getters.external_data);

export const readSearchEngine = read(getters.search_engine);

export const readFormBatches = read(getters.form_batches);
export const readFormBatchesStats = read(getters.form_batches_stats);
export const readFormBatch = read(getters.form_batch);

export const readQueryBuilder = read(getters.query_builder);

export const readPrinterLog = read(getters.printer_log);
export const readPrinterLogs = read(getters.printer_logs);
export const readCurrentPrinterLog = read(getters.current_printer_log);


export const readAccessLog = read(getters.access_log);
export const readAccessLogs = read(getters.access_logs);

export const readVisitedPages = read(getters.visited_pages);


export const readPermissions = read(getters.permissions);
